module.exports = __webpack_public_path__ + "img/589.75d80265.svg";